<template>
  <div>
    <default-header :h2="$t('otherBattery.title')"></default-header>
    <back-btn :shouldShowModal="true"></back-btn>

    <div class="innerContent">
      <div class="spaceBetween">
        <div class="circle-background additionalPadding">
          <!-- <select-standard
            :list="brands"
            :name="'brand'"
            :chosen="battery.brand"
            :label="$t('otherBattery.batteryBrand')"
            :fromOtherBatteryModel="true"
            :error="brandError ? $t('otherBattery.brandFieldRequired') : false"
            @selected="inputChangedValue"
          />-->

          <input-standard
            :label="$t('otherBattery.batteryBrand')"
            :name="'brand'"
            :type="'text'"
            :error="brandError ? $t('otherBattery.brandFieldRequired') : false"
            @changedValue="inputChangedValue"
          />

          <input-standard
            :label="$t('report.model')"
            :name="'model'"
            :type="'text'"
            :error="modelError ? $t('otherBattery.modelFieldRequired') : false"
            @changedValue="inputChangedValue"
          />

          <input-standard
            :label="$t('otherBattery.capacityAh')"
            :name="'capacity'"
            :type="'number'"
            :error="capacityError ? $t('otherBattery.capacityFieldRequired') : false"
            @changedValue="inputChangedValue"
          />
        </div>
        <div>
          <button
            class="btn btn-primary w-100 p-2 mb-3 additionalMarginTop btn-outline-primary"
            @click.prevent="addBatteryToQuote"
          >{{$t('general.addtoQuote')}}</button>
          <button
            class="btn btn-primary w-100 p-2 additionalMarginTop"
            @click.prevent="goToQuote"
            :disabled="chosenBatteries.length === 0 ? true : false"
          >{{$t('general.continue')}}</button>
        </div>
      </div>
    </div>
    <bottom-navigation></bottom-navigation>
  </div>
</template>

<script>
import DefaultHeader from '../partials/DefaultHeader';
import BottomNavigation from '../partials/BottomNavigation';
import InputStandard from '../components/InputStandard';
import SelectStandard from '../components/SelectStandard';
import { HTTP } from '../http';
import BackBtn from '../components/BackBtn';
import { mapActions, mapGetters } from 'vuex';
const ids = require('short-id');
export default {
  name: 'AddOtherBatteryModel',
  components: {
    DefaultHeader,
    BottomNavigation,
    InputStandard,
    SelectStandard,
    BackBtn
  },
  computed: {
    ...mapGetters({ user: 'getUser', chosenBatteries: 'getChosenBatterries' }),
    brands() {
      return this.countries.filter(country => country.country == this.user.country);
    }
  },
  data() {
    return {
      battery: {
        brand: null,
        model: null,
        capacity: null,
        id: null
      },
      brandError: false,
      capacityError: false,
      modelError: false,

      countries: [],
      msg: '',
      alertType: ''
    };
  },
  beforeMount() {
    HTTP.get('api/app/config').then(res => {
      this.countries = res.data.countries;
    });
  },

  methods: {
    ...mapActions(['getConfigFromBackend']),
    goToQuote() {
      this.$router.push({ name: 'Quote' });
    },
    inputChangedValue(name, value) {
      this.battery[name] = value;
    },
    validateInputs() {
      let errors = 0;
      this.brandError = false;
      this.modelError = false;
      this.capacityError = false;
      if (!this.battery.brand) {
        this.brandError = true;
        errors++;
      }
      if (!this.battery.model) {
        this.modelError = true;
        errors++;
      }
      if (!this.battery.capacity) {
        this.capacityError = true;
        errors++;
      }
      return errors === 0 ? true : false;
    },
    addBatteryToQuote() {
      if (this.validateInputs()) {
        if (this.chosenBatteries.length < 3) {
          this.$store.commit('addToChosenBatteries', {
            id: 'custom-' + ids.generate(),
            manufacturer: this.battery.brand,
            model: this.battery.model,
            capacity: this.battery.capacity + 'Ah',
            cost_separately: false,
            service_price: 0,
            battery_price: 0,
            comment: ''
          });
          this.$toasted.show(this.$i18n.t('testResult.batteryAddedToQuote'), {
            className: 'success'
          });
        } else {
          this.$toasted.show(this.$i18n.t('otherBattery.batteryIsAlreadyAddedToQuote'));
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.circle-background {
  padding-top: 60px;
  margin-top: 20px;
  background: linear-gradient(180deg, #ededed 0%, rgba(237, 237, 237, 0) 100%);
  border-radius: 50%;
  margin-bottom: 0px;
  min-height: 320px;
}
</style>